module.exports = __webpack_public_path__ + "img/orangeBarEnd.8c477287.svg";